import {
  computed,
  ref,
  toRef,
} from "vue";
import { isArray } from "lodash-es";

export default function SortAPI(props, {
  filterPrioritization = ref(undefined), // 1) Url 2) Session 3) Default
  modelSortLocal = ref(undefined),
  reloadData = () => {},
}) {
  const isSortingOutside = toRef(props, "isSortingOutside");
  const sortable = toRef(props, "sortable");
  const url = toRef(props, "url");

  const isSortingOutsideLocal = computed(() => {
    if (!url.value || isSortingOutside.value === false) {
      return false;
    }
    return isSortingOutside.value;
  });

  const useUrlParametersSorting = computed(() => {
    if (!sortable.value || !isSortingOutsideLocal.value) {
      return false;
    }
    if (isArray(modelSortLocal.value)) {
      return modelSortLocal.value.length > 0;
    }
    return !!modelSortLocal.value;
  });

  const initSorting = ({ ordering, filtersPropsAndFromAPI: _filtersPropsAndFromAPI }) => {
    if (!sortable.value || !ordering) {
      return;
    }
    if (_filtersPropsAndFromAPI) {
      filterPrioritization.value = _filtersPropsAndFromAPI;
    }
    modelSortLocal.value = ordering;
  };

  const changeSorting = ({ modelSort }) => {
    modelSortLocal.value = modelSort;
    if (isSortingOutsideLocal.value) {
      reloadData();
    }
  };

  return {
    changeSorting,
    initSorting,
    isSortingOutsideLocal,
    useUrlParametersSorting,
  };
}
